var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',{attrs:{"loading":_vm.loading},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('router-view',{on:{"setLoading":function($event){_vm.loading = $event}}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }